export const ApartmentViewerServiceEndpoints = {
    getApartmentData: (stageId: string, objectId: string) =>  `/residenceexplorer/get360/${stageId}/${objectId}`,
    getQHDRFile: (stageId: string, visuadoApartmentId: string, archetypeName: string, markerId: string, ext: string) =>
        `/externalfiles/image/residenceexplorer/${stageId}/360/${visuadoApartmentId}/${archetypeName}/${markerId}${ext}`,
}

export const ApartmentViewerServiceQueryKeys = {
    getApartmentData: (stageId: string, objectId: string) => ['apartmentViewer', stageId, objectId],
}
